import {
  Grid,
  notifyError,
  Skeleton,
  Stack,
} from '@omnipresentgroup/design-system';
import { useEffect } from 'react';
import { useLocation } from 'react-router';

const getPasswordChangeUrl = async (apiUrl: string, token: string) => {
  const response = await fetch(`${apiUrl}/auth/change-pw?token=${token}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error(
      `Cannot generate the password change url - ${response.statusText}`,
    );
  }

  return response.json() as Promise<{ url: string }>;
};

export const ChangePassword = ({ apiUrl }: { apiUrl?: string }) => {
  const location = useLocation();

  useEffect(() => {
    const goToChangePasswordPage = async () => {
      if (!apiUrl) {
        return;
      }

      const token = new URLSearchParams(location.search).get('token') as string;
      try {
        const { url } = await getPasswordChangeUrl(apiUrl, token);
        window.location.assign(url);
      } catch {
        notifyError({
          title: `Something went wrong while getting the password change url,
          please logout and login again`,
        });
      }
    };

    goToChangePasswordPage();
  }, [location.search]);

  return (
    <Grid bg="page" css={{ height: '100vh' }}>
      <Stack justify="center" align="center">
        <Skeleton width={'20vw'} height={'40vh'} />
      </Stack>
    </Grid>
  );
};
